import type { DeviceType } from '~/types/device-type'
import type { ITranslationKeyValue } from '~/types/translation'

import { getSearchClient, getTranslationFilters } from '~/utils/algolia'

export const getTranslationValues = async ({
  deviceType,
  lokaliseId,
  translationKeys,
}: {
  deviceType: DeviceType
  lokaliseId: string
  translationKeys: string[]
}): Promise<ITranslationKeyValue[]> => {
  const queryClient = getSearchClient()
  const index = queryClient.initIndex('translations')
  const keyQueryString = translationKeys.join(' OR key:')
  const filters = getTranslationFilters({
    deviceType,
    lokaliseId,
  })
  const results = await index.search('', {
    filters: `${filters} AND (key:${keyQueryString})`,
    hitsPerPage: 100,
  })

  return results.hits as ITranslationKeyValue[]
}
